export const INJECTED_COLOR_MODE = 'INJECTED_COLOR_MODE';

export const QUERY_PARAM_LOGGEDIN = 'loggedIn';
export const QUERY_PARAM_LOGGOUT = 'loggedOut';
